import React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteAlertActive, selectSiteAlertMessage } from '../store/slices/siteAlertSlice';
import AlertBannerMessage from './AlertBannerMessage';

const SiteAlertBanner = () => {
  const active = useSelector(selectSiteAlertActive);
  const message = useSelector(selectSiteAlertMessage);

  if (!active) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50 h-10 flex items-center bg-primary-600 px-4">
      <AlertBannerMessage message={message} />
    </div>
  );
};

export default SiteAlertBanner;
